/**
 * Fecha límite de RSVP (008 · US1 · F2 · R7).
 *
 * Se persiste como instante absoluto (`TIMESTAMPTZ`). La pareja la introduce en **hora local
 * del evento**; asumimos la zona horaria de **Bolivia (UTC−4, sin horario de verano)**. Si en el
 * futuro se soportan otras zonas, se añade una columna de zona al evento y se parametriza aquí.
 */
const EVENT_TZ_OFFSET = '-04:00'; // Bolivia (UTC−4)
const EVENT_TZ_MS = 4 * 60 * 60 * 1000;

/** Valor de un `<input type="datetime-local">` ("YYYY-MM-DDTHH:mm") → ISO absoluto (o null). */
export function deadlineInputToISO(local: string): string | null {
  if (!local) return null;
  const d = new Date(`${local}:00${EVENT_TZ_OFFSET}`);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

/** ISO absoluto → valor local ("YYYY-MM-DDTHH:mm") para el input, en la TZ del evento. */
export function isoToDeadlineInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  // Desplazar a UTC−4 y formatear las partes como "wall time".
  return new Date(d.getTime() - EVENT_TZ_MS).toISOString().slice(0, 16);
}

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

/**
 * ISO absoluto → texto de fecha límite para mostrar en la invitación ("30 de septiembre").
 *
 * Formatea la **fecha** en la zona del evento (Bolivia, UTC−4). No usamos `parseCalendarDate`
 * porque este valor es un instante con hora de pared (p. ej. 21:00 en Bolivia cae al día
 * siguiente en UTC): hay que desplazar a UTC−4 antes de tomar el día. Sin año, para
 * espejar la copia existente ("…antes del {fecha}").
 */
export function formatDeadlineDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const local = new Date(d.getTime() - EVENT_TZ_MS); // hora de pared del evento en getters UTC
  return `${local.getUTCDate()} de ${MESES[local.getUTCMonth()]}`;
}
